import React from "react";
import { useNavigate } from "react-router-dom";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center">
      <p className="font-display text-4xl text-white uppercase">Checkout Cancelled</p>
      <p className="text-zinc-400 text-sm mt-2 max-w-sm">Your order was not completed and you were not charged. Your tickets are still available.</p>
      <button onClick={() => navigate("/events")} className="btn-gold mt-6 rounded-md px-6 py-3 font-oswald tracking-widest text-sm">BACK TO EVENTS</button>
    </div>
  );
}
